<table class="table table-striped webtext-black">
  <thead>
    <tr>
      <th style="width:35%">Organization
        <app-st-button-sort-text-asc *ngIf="this.sortedDescCompanyName" [idVal]="'sort-company-name-asc-button-id'" [label]="''" [primary]="false" (click)="this.sortTextCompanyName()">

        </app-st-button-sort-text-asc>
        <app-st-button-sort-text-desc *ngIf="!this.sortedDescCompanyName" [idVal]="'sort-company-name-desc-button-id'" [label]="''" [primary]="false" (click)="this.sortTextCompanyName()">

        </app-st-button-sort-text-desc>
      </th>
      <th style="width:15%">EIN</th>
      <th style="width:15%">City
        <app-st-button-sort-text-asc *ngIf="this.sortedDescCity" [idVal]="'sort-city-asc-button-id'" [label]="''" [primary]="false" (click)="this.sortTextCity()">

        </app-st-button-sort-text-asc>
        <app-st-button-sort-text-desc *ngIf="!this.sortedDescCity" [idVal]="'sort-city-desc-button-id'" [label]="''" [primary]="false" (click)="this.sortTextCity()">

        </app-st-button-sort-text-desc>
      </th>
      <th style="width:5%">State</th>
      <th style="width:15%">Zip Code</th>
      <th style="width:15%">Total Assets
        <app-st-button-sort-number-asc *ngIf="this.sortedDescTotalAssets" [idVal]="'sort-total-assets-asc-button-id'" [label]="''" [primary]="false" (click)="this.sortNumberTotalAssets()">

        </app-st-button-sort-number-asc>
        <app-st-button-sort-number-desc *ngIf="!this.sortedDescTotalAssets" [idVal]="'sort-total-assets-desc-button-id'" [label]="''" [primary]="false" (click)="this.sortNumberTotalAssets()">

        </app-st-button-sort-number-desc>
      </th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let row of rows">
      <td>{{row['companyName']}}&nbsp;<i class="bi bi-search btn" (click)="onViewDetails(row)"></i></td>
      <td>{{this.formatEin(row['ein'])}}</td>
      <td>{{row['taxFilingCity']}}</td>
      <td>{{row['taxFilingState']}}</td>
      <td>{{this.formatZip(row['taxFilingZipCode'])}}</td>
      <td>{{row['totalAssetsFormatted']}}</td>
    </tr>
  </tbody>
</table>
